import {
  RazorInputField,
  RazorToggleSlide,
} from "../../../../components/razor-reuse";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import {
  createExchangeRate,
  getExchangeRateForCreate,
} from "../../../../redux/settings";
import RootState from "../../../../redux/type";
import { reactSelectStyleTable } from "../../../../utils/Helper";
import ExchangeCurrencyText from "../../../../components/fragment/cur-text/ExchangeCurrencyText";
import { debounce } from "lodash";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
}

const AddExchangeRateModal = ({
  onClose,
  visible,
  onFinish,
}: myComponentProps) => {
  type detailProps = {
    rate: string;
    base: any;
    desination: any;
    fx_rate: string;
    fx_type: any;
    percentage_mark: string;
    effective_rate: string | number;
    status: boolean;
    provider: string;
    rate_user_type: any;
  };
  const [details, setDetails] = useState<detailProps>({
    rate: "",
    base: "",
    desination: "",
    fx_rate: "",
    fx_type: "",
    percentage_mark: "",
    effective_rate: "",
    status: false,
    provider: "",
    rate_user_type: "",
  });
  const [step, setStep] = useState(1);
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const { loadingDelete, all_currencies_drop, loadingFetch } = useSelector(
    (state: RootState) => state.settings,
  );
  const dispatch = useDispatch();

  const formatLabelForCurrency = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return {
          ...chi,
          imageUrl: chi?.logo,
        };
      });
      return newList;
    }
  };

  // Custom label component for options with images
  const formatOptionLabel = ({ label, imageUrl }: any) => (
    <>
      <CurrencyText
        url={
          label === "USD"
            ? ""
            : label === "EUR"
              ? ""
              : label === "GBP"
                ? ""
                : label === "NGN"
                  ? ""
                  : imageUrl
        }
        currency={label}
        text={label}
      />
    </>
  );

  const formatDropDownOption = () => {
    const objSelectedList = [
      {
        label: `${details?.base?.label} - ${details?.desination?.label}`,
        value: `${details?.base?.value},${details?.desination?.value}`,
        fromLabel: details?.base?.label,
        toLabel: details?.desination?.label,
        imageUrl: ``,
      },
    ];
    return objSelectedList;
  };

  const formatOptionLabelTwo = ({ label, fromLabel, toLabel, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <ExchangeCurrencyText
            // loading={}
            curOne={fromLabel || "NIL"}
            curTwo={toLabel || "NIL"}
            urlOne={
              fromLabel === "USD"
                ? ""
                : fromLabel === "EUR"
                  ? ""
                  : fromLabel === "GBP"
                    ? ""
                    : fromLabel === "NGN"
                      ? ""
                      : fromLabel === "CAD"
                        ? ""
                        : ""
            }
            urlTwo={
              toLabel === "USD"
                ? ""
                : toLabel === "EUR"
                  ? ""
                  : toLabel === "GBP"
                    ? ""
                    : toLabel === "NGN"
                      ? ""
                      : toLabel === "CAD"
                        ? ""
                        : ""
            }
          />
        </>
      );
    }
  };

  const removeFromList = () => {
    if (all_currencies_drop?.length > 0) {
      // Since we are add local exchange we are muting this function
      // const newList = formatLabelForCurrency(all_currencies_drop)?.filter(
      //   (chi: any) => chi?.id !== details?.base?.id
      // );
      const newList = formatLabelForCurrency(all_currencies_drop);
      return newList;
    }
  };

  const handleSubmit = async () => {
    if (step === 1 && details?.fx_rate) {
      setStep(2);
      return;
    }
    if (step === 2) {
      const obj = {
        // rate: RazorNumberFormat(details?.rate, { convertToNumber: true }),
        destination_currency: details?.desination?.id,
        source_currency: details?.base?.id,
        fx_type: details?.fx_type?.value,
        status: details?.status ? "active" : "inactive",
        markup_percentage: details?.percentage_mark,
        effective_rate: details?.effective_rate,
        fx_rate: details?.fx_rate,
        provider: details?.provider,
        rate_user_type: details?.rate_user_type?.value,
      };

      const data = await dispatch(createExchangeRate(obj) as any);

      if (data?.payload?.data?.status) {
        setDetails({
          rate: "",
          base: "",
          desination: "",
          fx_rate: "",
          fx_type: "",
          percentage_mark: "",
          effective_rate: "",
          status: false,
          provider: "",
          rate_user_type: "",
        });
        handleClose();
        onFinish?.();
      }
    }
  };

  function isNumberOrDecimalOnly(input: string): boolean {
    // Allow empty string or string with spaces
    if (input.trim() === "") {
      return true;
    }

    // Regular expression to check if the string contains only digits and one optional '.'
    const validCharactersRegex = /^[0-9.]+$/;

    // Ensure only valid characters exist and at most one '.'
    if (!validCharactersRegex.test(input) || input.split(".").length > 2) {
      return false;
    }

    return true;
  }

  const getFXExchangeRate = async () => {
    const obj = {
      destination_currency: details?.desination?.value,
      source_currency: details?.base?.value,
    };

    const data = await dispatch(getExchangeRateForCreate(obj) as any);

    if (data?.payload?.data?.status) {
      const rate = data?.payload?.data?.data?.rate;
      const provider = data?.payload?.data?.data?.provider;
      setDetails((prev) => {
        return { ...prev, fx_rate: rate, provider: provider };
      });
      setStep(2);
    }
    
    // setStep(2)
  };

  useEffect(() => {
    if (details?.base && details?.desination && step === 1) {
      getFXExchangeRate();
    }
  }, [details?.base, details?.desination]);

  const selectTypeOption = [
    { label: "Buy", value: "buy" },
    { label: "Sell", value: "sell" },
  ];

  const getEffectiverate = debounce(() => {
    // let val;
    if (details?.fx_type?.value === "buy") {
      const mathVal =
        Number(details?.fx_rate) -
        (Number(details?.fx_rate) * Number(details?.percentage_mark)) / 100;
      setDetails((prev) => {
        return {
          ...prev,
          effective_rate: String(mathVal) === "0" ? "0" : mathVal,
        };
      });
    }
    if (details?.fx_type?.value === "sell") {
      const mathVal =
        Number(details?.fx_rate) +
        (Number(details?.fx_rate) * Number(details?.percentage_mark)) / 100;
      setDetails((prev) => {
        return {
          ...prev,
          effective_rate: String(mathVal) === "0" ? "0" : mathVal,
        };
      });
    }
  }, 500);

  useEffect(() => {
    if (
      details?.fx_rate &&
      details?.percentage_mark &&
      details?.fx_type &&
      step === 2
    ) {
      getEffectiverate();
    }
  }, [details?.percentage_mark, details?.fx_type, details?.fx_rate, step]);

  const handleClose = () => {
    setDetails({
      rate: "",
      base: "",
      desination: "",
      fx_rate: "",
      fx_type: "",
      percentage_mark: "",
      effective_rate: "",
      status: false,
      provider: "",
      rate_user_type: "",
    });
    setStep(1);
    onClose?.();
  };

  const formatRateUserOption = [
    {
      label: `Mobile`,
      value: `customer`,
    },
    {
      label: `Business`,
      value: `business`,
    },
  ];

  return (
    <>
      <ReuseModal
        title="New Currency"
        btnLabel="Save Rate"
        visible={visible}
        onClose={handleClose}
        disable={
          step === 1
            ? !details?.base || !details?.desination
            : step === 2
              ? !details?.fx_type ||
                !details?.effective_rate ||
                !details?.fx_rate ||
                !details?.percentage_mark ||
                !details?.rate_user_type ||
                !details?.effective_rate
              : false
        }
        loading={loadingDelete || loadingFetch}
        onBtnClick={handleSubmit}
        loadingText={step === 1 ? "Fetching FX rate" : ""}
        onCancel={() => {
          if (step === 1) {
            handleClose();
          } else {
            setStep(1);
          }
        }}
        cancelText={step === 2 ? "Back" : ""}
      >
        <div className="add-exchange-currency-modal-wrap">
          {/* step 1 start -------------------------- */}
          {step === 1 && (
            <>
              {/* input here */}
              <RazorInputField
                color="black-light"
                type="select"
                placeholder="Select currency"
                label="Base Currency"
                style={{ position: "relative", zIndex: 3 }}
                selectOption={formatLabelForCurrency(all_currencies_drop)}
                onChange={(e: any) => {
                  // console.log(e);
                  setDetails((prev) => {
                    return {
                      ...prev,
                      base: e,
                      desination:
                        e.id === details?.desination?.id
                          ? ""
                          : details?.desination,
                    };
                  });
                }}
                value={details?.base}
                selectStyles={reactSelectStyleTable}
                formatOptionLabel={formatOptionLabel}
                // selectMenuOpen
              />
              {/* input here */}
              {/* input here */}
              <RazorInputField
                color="black-light"
                type="select"
                placeholder="Select currency"
                label="Destination Currency"
                style={{ position: "relative", zIndex: 2 }}
                disabled={!details?.base}
                selectOption={removeFromList()}
                formatOptionLabel={formatOptionLabel}
                value={details?.desination}
                selectStyles={reactSelectStyleTable}
                onChange={(e: any) => {
                  setDetails((prev) => {
                    return {
                      ...prev,
                      desination: e,
                    };
                  });
                }}
                // labelSpanText={

                // }
              />
              {/* input here */}
            </>
          )}
          {/* step 1 end -------------------------- */}
          {/* step 2 start -------------------------- */}
          {step === 2 && (
            <>
              <RazorInputField
                color="black-light"
                type="select"
                placeholder="Select  Currency Pair"
                label=" Currency Pair"
                disabled
                style={{ position: "relative", zIndex: 3 }}
                selectOption={formatDropDownOption()}
                onChange={(e: any) => {}}
                value={formatDropDownOption()[0]}
                selectStyles={reactSelectStyleTable}
                formatOptionLabel={formatOptionLabelTwo}
                // selectMenuOpen
                // labelSpanText={
                //   details?.fx_rate
                //     ? `1 ${details?.base?.label} ==> ${details?.fx_rate} ${details?.desination?.label}`
                //     : ""
                // }
              />
              <RazorInputField
                disabled
                value={details?.fx_rate}
                color="black-light"
                label="Current FX Rate"
                type={`text`}
                placeholder=" "
              />
              <RazorInputField
                color="black-light"
                type="select"
                placeholder="Select rate user"
                label="Exchange Rate User Type"
                style={{ position: "relative", zIndex: 3 }}
                selectOption={formatRateUserOption}
                value={details?.rate_user_type}
                selectStyles={reactSelectStyleTable}
                onChange={(e: any) => {
                  setDetails((prev) => {
                    return {
                      ...prev,
                      rate_user_type: e,
                    };
                  });
                }}
              />
              <RazorInputField
                color="black-light"
                type="select"
                placeholder="Select FX Type"
                label="FX Type"
                style={{ position: "relative", zIndex: 2 }}
                // disabled={!details?.base}
                selectOption={selectTypeOption}
                // formatOptionLabel={formatOptionLabel}
                value={details?.fx_type}
                selectStyles={reactSelectStyleTable}
                onChange={(e: any) => {
                  setDetails((prev) => {
                    return {
                      ...prev,
                      fx_type: e,
                    };
                  });
                }}
              />
              <RazorInputField
                color="black-light"
                type="text"
                placeholder="Set Percentage Mark"
                label="Percentage Mark%"
                style={{ position: "relative", zIndex: 1 }}
                value={details?.percentage_mark}
                onChange={(e: any) => {
                  if (
                    isNumberOrDecimalOnly(e.target.value) &&
                    Number(e.target.value) <= 100
                  ) {
                    handleChange(e);
                  }
                  // handleChange(e)
                }}
                name="percentage_mark"
                thousandFormat
                labelSpanText={
                  details?.percentage_mark && details?.fx_type?.value === "sell"
                    ? `${details?.percentage_mark}%`
                    : details?.percentage_mark &&
                        details?.fx_type?.value === "buy"
                      ? `-${details?.percentage_mark}%`
                      : ""
                }
              />
              <RazorInputField
                disabled
                value={details?.effective_rate}
                color="black-light"
                label="Effective Rate"
                type={`text`}
                placeholder=" "
              />
              <div className="activate-currency-pair-box">
                <RazorToggleSlide
                  color={`black-light`}
                  value={details?.status}
                  onChange={() => {
                    setDetails((prev) => {
                      return { ...prev, status: !details?.status };
                    });
                  }}
                />
                <div className="label">Activate currency pair</div>
              </div>
            </>
          )}
          {/* step 2 end -------------------------- */}
        </div>

        {/* input here */}
        {/* <RazorInputField
          color="black-light"
          type="text"
          placeholder="Set exchange rate"
          label="Exchange Rate"
          style={{ position: "relative", zIndex: 1 }}
          value={details?.rate}
          onChange={(e: any) => {
            if(isNumberOrDecimalOnly(e.target.value)){
              handleChange(e)
            }
            // handleChange(e)
          }}
          name="rate"
          thousandFormat
        /> */}
        {/* input here */}
      </ReuseModal>
    </>
  );
};

export default AddExchangeRateModal;
